'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var PATH = exports.PATH = {
    VECTOR: 0,
    BEZIER_CURVE: 1,
    CIRCLE: 2
};


//////////////////
// WEBPACK FOOTER
// ./~/html2canvas/dist/npm/drawing/Path.js
// module id = 205
// module chunks = 0